import { Dispatch } from 'redux';
import {
    AppAction,
    setIsAppRebrandActiveFromInitialStateAction,
} from '../actions/app';
import { CheckoutState } from '../state/index';

/**
 * Checks if there is an initial state with is_app_rebrand_active in app.request.params
 * and dispatches an action to set the isAppRebrandActiveFromInitialState property in the Redux store.
 *
 * @param initialState - The initial Redux state loaded from session storage
 * @param dispatch - Redux store dispatch function
 * @returns true if is_app_rebrand_active is 'true', false otherwise
 */
export const initializeAppRebrandFromParams = (
    initialState: CheckoutState,
    dispatch: Dispatch<AppAction>,
): boolean => {
    if (!initialState || !initialState.app?.request?.params) {
        return false;
    }

    const isAppRebrandActiveParam =
        initialState.app.request.params.is_app_rebrand_active;

    if (isAppRebrandActiveParam === undefined) {
        return false;
    }

    const isAppRebrandActiveFromInitialState =
        isAppRebrandActiveParam === 'true';

    dispatch(
        setIsAppRebrandActiveFromInitialStateAction(
            isAppRebrandActiveFromInitialState,
        ),
    );

    return isAppRebrandActiveFromInitialState;
};
